import * as React from 'react';

import BottomNavigation from './bottomNavigation';
import ReadAndHighlightInstructions from './readAndHighlightInstructions';
import GoodToKnow from './goodToKnow';
import StepOverview from './stepOverview';
import Steps from './steps';

import { READ_PASSAGE_STEP } from '../../helpers/containerActionHelpers';

const RightPanel = ({
  activities,
  activateStep,
  activeStep,
  activityIsComplete,
  handleReadTheDirectionsButtonClick,
  completeStep,
  completedSteps,
  completionButtonCallback,
  doneHighlighting,
  handleClickDoneHighlighting,
  handleDoneReadingClick,
  hasStartedPromptSteps,
  hasStartedReadPassageStep,
  onStartPromptSteps,
  onStartReadPassage,
  reportAProblem,
  resetTimers,
  scrolledToEndOfPassage,
  session,
  onShowGoodToKnow,
  showGoodToKnow,
  showReadTheDirectionsButton,
  showStepsSummary,
  studentHighlights,
  submitResponse,
  toggleShowStepsSummary,
  toggleStudentHighlight,
}) => {

  const bottomNavigation = (<BottomNavigation
    doneHighlighting={doneHighlighting}
    handleClickDoneHighlighting={handleClickDoneHighlighting}
    handleDoneReadingClick={handleDoneReadingClick}
    handleGoodToKnowClick={onShowGoodToKnow}
    handleReadTheDirectionsButtonClick={handleReadTheDirectionsButtonClick}
    handleStartPromptStepsClick={onStartPromptSteps}
    handleStartReadingPassageClick={onStartReadPassage}
    hasStartedPromptSteps={hasStartedPromptSteps}
    hasStartedReadPassageStep={hasStartedReadPassageStep}
    inReflection={doneHighlighting && activeStep === READ_PASSAGE_STEP}
    scrolledToEndOfPassage={scrolledToEndOfPassage}
    showGoodToKnow={showGoodToKnow}
    showReadTheDirectionsButton={showReadTheDirectionsButton}
    showStepsSummary={showStepsSummary}
    studentHighlights={studentHighlights}
    toggleShowStepsSummary={toggleShowStepsSummary}
  />)

  if (!hasStartedReadPassageStep) {
    return (
      <section aria-label="Steps" className="steps-outer-container step-overview-container" onScroll={resetTimers}>
        {showGoodToKnow ? <GoodToKnow /> : (
          <StepOverview
            activeStep={activeStep}
            activities={activities}
            handleClick={onShowGoodToKnow}
          />
        )}
        {bottomNavigation}
      </section>
    )
  }

  if (activeStep === READ_PASSAGE_STEP) {
    return (
      <section aria-label="Steps" className="steps-outer-container" onScroll={resetTimers}>
        <ReadAndHighlightInstructions
          inReflection={doneHighlighting && activeStep === READ_PASSAGE_STEP}
          passage={activities.currentActivity.passages[0]}
          removeHighlight={toggleStudentHighlight}
          studentHighlights={studentHighlights}
        />
        {bottomNavigation}
      </section>
    )
  }

  if (!hasStartedPromptSteps) {
    return (
      <section aria-label="Steps" className="steps-outer-container step-overview-container" onScroll={resetTimers}>
        <StepOverview
          activeStep={activeStep}
          activities={activities}
          handleClick={onStartPromptSteps}
        />
        {bottomNavigation}
      </section>
    )
  }

  if (showStepsSummary) {
    return (
      <section aria-label="Steps" className="steps-outer-container step-overview-container" onScroll={resetTimers}>
        <StepOverview
          activeStep={activeStep}
          activities={activities}
          handleClick={toggleShowStepsSummary}
        />
        {bottomNavigation}
      </section>
    )
  }

  return(
    <Steps
      activateStep={activateStep}
      activeStep={activeStep}
      activities={activities}
      activityIsComplete={activityIsComplete}
      completedSteps={completedSteps}
      completeStep={completeStep}
      completionButtonCallback={completionButtonCallback}
      doneHighlighting={doneHighlighting}
      handleDoneReadingClick={handleDoneReadingClick}
      handleReadTheDirectionsButtonClick={handleReadTheDirectionsButtonClick}
      reportAProblem={reportAProblem}
      resetTimers={resetTimers}
      session={session}
      showReadTheDirectionsButton={showReadTheDirectionsButton}
      submitResponse={submitResponse}

    />
  )
}

export default RightPanel;
